var identity = function identity(x) {
  return x;
};

export default identity;


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/esm/utils/identity.js
// module id = 23
// module chunks = 0